import React, { useEffect, useState, useRef } from 'react';
import { API_URLS } from '../apiUrl';
import axiosInstance from '../components/axiosInstance';

const HoldingEdit = ({
  isOpen,
  closeModal,
  muniCipalityName,
  muniCipalityId,
  holdingId,
  streetId,
  holdingNo,
  holdingType,
  nameOfComp,
  coverArea,
  proeprtyLocation,
  jlNo,
  khatiyanNo,
  fatherName,
  annualValuation,
  quaterlyTax,
  mouzaName,
  propertyYear,
  owner,
  calcAcr,
  calcBigha,
  calcKatha,
  calcChatak,
  calcSatak,
  landSqft
}: any) => {

  const [inputValues, setInputValues] = useState<any>({
    holdingNo,
    holdingType,
    nameOfComp,
    coverArea,
    proeprtyLocation,
    jlNo,
    khatiyanNo,
    fatherName,
    annualValuation,
    quaterlyTax,
    mouzaName,
    propertyYear,
    owner,
    calcAcr,
    calcBigha,
    calcKatha,
    calcChatak,
    calcSatak,
    landSqft
  });

  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [formStatus, setFormStatus] = useState<{ type: string; message: string } | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (holdingNo && holdingId) {
      setInputValues((prevValues: any) => ({
        ...prevValues,
        holdingNo,
        holdingType,
        nameOfComp,
        coverArea,
        proeprtyLocation,
        jlNo,
        khatiyanNo,
        fatherName,
        annualValuation,
        quaterlyTax,
        mouzaName,
        propertyYear,
        owner,
        calcAcr,
        calcBigha,
        calcKatha,
        calcChatak,
        calcSatak,
        landSqft
      }));
    }
  }, [holdingNo, holdingId, holdingType,
    nameOfComp,
    coverArea,
    proeprtyLocation,
    jlNo,
    khatiyanNo,
    fatherName,
    annualValuation,
    quaterlyTax,
    mouzaName,
    propertyYear,
    owner,
    calcAcr,
    calcBigha,
    calcKatha,
    calcChatak,
    calcSatak,
    landSqft]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
    setInputValues({
      ...inputValues,
      [field]: event.target.value
    });
  };


  const validateForm = () => {
    let valid = true;
    const newErrors: { [key: string]: string } = {};

    Object.keys(inputValues).forEach((field) => {
      const fieldValue = inputValues[field];
      if (fieldValue && typeof fieldValue === 'string' && !fieldValue.trim()) {
        newErrors[field] = `${field} is required`;
        valid = false;
      }
    });

    setFormErrors(newErrors);
    return valid;
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const updatedFormData = {
      municipalityTbl_id: muniCipalityId,
      holdingTbl_id: holdingId,
      street_tbl_id: streetId,
      holding_no: inputValues.holdingNo || null,
      holding_type: inputValues.holdingType || null,
      name_of_complex_apartment: inputValues.nameOfComp || null,
      cover_area: inputValues.coverArea || null,
      property_location: inputValues.proeprtyLocation || null,
      property_JL_no: inputValues.jlNo || null,
      property_khatiyan_no: inputValues.khatiyanNo || null,
      property_owner_spouse_name_father_name: inputValues.fatherName || null,
      property_annual_valuation: inputValues.annualValuation || null,
      property_quaterly_tax: inputValues.quaterlyTax || null,
      holding_mouza_name: inputValues.mouzaName || null,
      year_of_property: inputValues.propertyYear || null,
      ownership: inputValues.owner || null,
      land_plot_area_calc_acar: inputValues.calcAcr || null,
      land_plot_area_calc_bigha: inputValues.calcBigha || null,
      land_plot_area_calc_katha: inputValues.calcKatha || null,
      land_plot_area_calc_chatak: inputValues.calcChatak || null,
      land_plot_area_calc_satak_decimal: inputValues.calcSatak || null,
      land_sqft: inputValues.landSqft || null,
    };

    try {
      const response = await axiosInstance.put(`${API_URLS.HoldingUpdate}`, updatedFormData);

      if (response.data.message) {
        setFormStatus({
          type: "success",
          message: `Holding updated successfully!`,
        });
      }

      setTimeout(() => {
        setFormStatus(null);
        closeModal();
      }, 5000);

    } catch (error) {
      setFormStatus({
        type: "exists",
        message: "Duplicate entry found. Please check the data.",
      });

      setTimeout(() => {
        setFormStatus(null);
      }, 5000);
    }
  };

  const handleOutsideClick = (e: any) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center" onClick={handleOutsideClick}>
      <div className="bg-white p-6 rounded-lg shadow-lg w-[740px] relative" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-xl font-semibold mb-4">Edit Holding</h2>

        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {/* Municipality */}
            <div>
              <label htmlFor="municipalityTbl_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Municipality <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={muniCipalityName}
                id="municipalityTbl_id"
                name="municipalityTbl_id"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                disabled
              />
            </div>

            {/* Holding No. */}
            <div>
              <label htmlFor="holdingNo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Holding No. <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.holdingNo}
                onChange={(e) => handleInputChange(e, 'holdingNo')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Holding No."
                disabled={holdingNo != null}
              />
              {formErrors.holdingNo && <p className="text-red-600 text-sm mt-2">{formErrors.holdingNo}</p>}
            </div>

            {/* Holding Type */}
            <div>
              <label htmlFor="holdingType" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Holding Type <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.holdingType}
                onChange={(e) => handleInputChange(e, 'holdingType')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Holding Type"
                disabled={holdingType != null}
              />
              {formErrors.holdingType && <p className="text-red-600 text-sm mt-2">{formErrors.holdingType}</p>}
            </div>

            {/* Name of Complex/Apartment */}
            <div>
              <label htmlFor="nameOfComp" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Name of Complex/Apartment
              </label>
              <input
                type="text"
                value={inputValues.nameOfComp}
                onChange={(e) => handleInputChange(e, 'nameOfComp')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Name of Complex/Apartment"
                disabled={nameOfComp != null}
              />
              {formErrors.nameOfComp && <p className="text-red-600 text-sm mt-2">{formErrors.nameOfComp}</p>}
            </div>

            {/* Cover Area */}
            <div>
              <label htmlFor="coverArea" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Cover Area
              </label>
              <input
                type="text"
                value={inputValues.coverArea}
                onChange={(e) => handleInputChange(e, 'coverArea')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Cover Area"
                disabled={coverArea != null}
              />
              {formErrors.coverArea && <p className="text-red-600 text-sm mt-2">{formErrors.coverArea}</p>}
            </div>


            {/* JL No. */}
            <div>
              <label htmlFor="jlNo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                JL No.
              </label>
              <input
                type="text"
                value={inputValues.jlNo}
                onChange={(e) => handleInputChange(e, 'jlNo')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter JL No."
                disabled={jlNo != null}
              />
              {formErrors.jlNo && <p className="text-red-600 text-sm mt-2">{formErrors.jlNo}</p>}
            </div>

            {/* Khatiyan No. */}
            <div>
              <label htmlFor="khatiyanNo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Khatiyan No.
              </label>
              <input
                type="text"
                value={inputValues.khatiyanNo}
                onChange={(e) => handleInputChange(e, 'khatiyanNo')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Khatiyan No."
                disabled={khatiyanNo != null}
              />
              {formErrors.khatiyanNo && <p className="text-red-600 text-sm mt-2">{formErrors.khatiyanNo}</p>}
            </div>

            {/* Father Name */}
            <div>
              <label htmlFor="fatherName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Father Name
              </label>
              <input
                type="text"
                value={inputValues.fatherName}
                onChange={(e) => handleInputChange(e, 'fatherName')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Father Name"
                disabled={fatherName != null}
              />
              {formErrors.fatherName && <p className="text-red-600 text-sm mt-2">{formErrors.fatherName}</p>}
            </div>


            {/* Property Year */}
            <div>
              <label htmlFor="propertyYear" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Property Year <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.propertyYear}
                onChange={(e) => handleInputChange(e, 'propertyYear')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Property Year"
                disabled={propertyYear != null}
              />
              {formErrors.propertyYear && <p className="text-red-600 text-sm mt-2">{formErrors.propertyYear}</p>}
            </div>

            {/* Ownership */}
            <div>
              <label htmlFor="owner" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Ownership <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.owner}
                onChange={(e) => handleInputChange(e, 'owner')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Ownership"
                disabled={owner != null}
              />
              {formErrors.owner && <p className="text-red-600 text-sm mt-2">{formErrors.owner}</p>}
            </div>

            {/* Land Plot Area (Acr) */}
            <div>
              <label htmlFor="calcAcr" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Land Plot Area (Acr)
              </label>
              <input
                type="text"
                value={inputValues.calcAcr}
                onChange={(e) => handleInputChange(e, 'calcAcr')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Land Plot Area (Acr)"
                disabled={calcAcr != null}
              />
              {formErrors.calcAcr && <p className="text-red-600 text-sm mt-2">{formErrors.calcAcr}</p>}
            </div>

            {/* Land Plot Area (Bigha) */}
            <div>
              <label htmlFor="calcBigha" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Land Plot Area (Bigha)
              </label>
              <input
                type="text"
                value={inputValues.calcBigha}
                onChange={(e) => handleInputChange(e, 'calcBigha')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Land Plot Area (Bigha)"
                disabled={calcBigha != null}
              />
              {formErrors.calcBigha && <p className="text-red-600 text-sm mt-2">{formErrors.calcBigha}</p>}
            </div>

            {/* Land Plot Area (Katha) */}
            <div>
              <label htmlFor="calcKatha" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Land Plot Area (Katha) <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.calcKatha}
                onChange={(e) => handleInputChange(e, 'calcKatha')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Land Plot Area (Katha)"
                disabled={calcKatha != null}
              />
              {formErrors.calcKatha && <p className="text-red-600 text-sm mt-2">{formErrors.calcKatha}</p>}
            </div>

            {/* Land Plot Area (Chatak) */}
            <div>
              <label htmlFor="calcChatak" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Land Plot Area (Chatak) <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={inputValues.calcChatak}
                onChange={(e) => handleInputChange(e, 'calcChatak')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Land Plot Area (Chatak)"
                disabled={calcChatak != null}
              />
              {formErrors.calcChatak && <p className="text-red-600 text-sm mt-2">{formErrors.calcChatak}</p>}
            </div>

            {/* Land Plot Area (Satak) */}
            <div>
              <label htmlFor="calcSatak" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Land Plot Area (Satak)
              </label>
              <input
                type="text"
                value={inputValues.calcSatak}
                onChange={(e) => handleInputChange(e, 'calcSatak')}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter Land Plot Area (Satak)"
                disabled={calcSatak != null}
              />
              {formErrors.calcSatak && <p className="text-red-600 text-sm mt-2">{formErrors.calcSatak}</p>}
            </div>


            {/* Submit Button */}
            <div className="lg:col-span-3 sm:col-span-2 mt-3">
              <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Update
              </button>
            </div>
          </div>
        </form>


        {formStatus && (
          <div className={`mt-4 p-4 rounded-lg flex justify-between items-center ${formStatus.type === "success" ? "bg-green-600 text-white" : "bg-yellow-600 text-white"}`}>
            <span>{formStatus.message}</span>
            <button className="ml-4 text-white font-bold text-lg focus:outline-none" onClick={() => setFormStatus(null)}>&times;</button>
          </div>
        )}


        <button onClick={closeModal} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700">
          <i className="ri-close-line"></i>
        </button>
      </div>
    </div>
  );
};

export default HoldingEdit;
